import gql from 'graphql-tag'

// Performers
export const performersQuery = gql`
    query searchPerformers($first: Int, $last: Int, $after: ID, $eventId: EventID!, $filters: PerformerFilter, $sort: PerformerOrder) {
        event(id:$eventId) {
            performers(first: $first, last: $last, after: $after, filters: $filters, orderBy: $sort) {
                edges {
                    node {
                        about
                        attachment
                        attachmentName
                        facebook
                        id
                        instagram
                        linkedin
                        mugshot
                        name
                        jobtitle
                        company
                        twitter
                        website
                        youtube
                        locationType
                    }
                }
                pageInfo {
                    hasPreviousPage
                    hasNextPage
                    endCursor
                }
                totalCount
            }
        }
    }
`
